/**
 * Labstep
 *
 * @module screens/Overview/LogBoard
 * @desc Overview of a workspace - Log board
 */

import { Card } from 'labstep-web/core/Card/Card';
import { Icon } from 'labstep-web/core/Icon';
import { LogIndex } from 'labstep-web/screens/Log/Index';
import type React from 'react';
import type { LogBoardProps } from './types';

export const LogBoard: React.FC<LogBoardProps> = ({ group }) => (
  <Card
    header={
      <>
        <Icon name="history" /> Activity Log
      </>
    }
    size="tiny"
  >
    <LogIndex
      entityName={group.entityName}
      entityId={group.id}
      count={5}
    />
  </Card>
);
